import {
  AppWrapper,
  LoadingPage,
  Page,
  PopoverContextProvider,
} from '@trufla-technology/trumarket-react-design-system';
import { BrowserRouter } from 'react-router-dom';
import { MainContent } from './app/MainContent';
import { TruDomainWrapper } from '@trufla-technology/trufla-trudomain/dist/lib';
export const App = () => {
  const company = process.env.REACT_APP_AUTH_REALM;
  const baseURL = process.env.REACT_APP_API_URL;
  const authURL = process.env.REACT_APP_AUTH_URL;

  console.info('Config (auth, api):', authURL, baseURL);

  if (!authURL || !baseURL)
    return (
      <Page>
        {!authURL && <h1>REACT_APP_AUTH_URL Not Set in .env</h1>}
        {!baseURL && <h1>REACT_APP_API_URL Not Set in .env</h1>}
      </Page>
    );

  return (
    <BrowserRouter basename={'admin'}>
      <AppWrapper>
        <TruDomainWrapper
          company={company}
          appName="truadmin-web"
          authUrl={authURL}
          baseURL={baseURL}
          LoadingComponent={LoadingPage}
        >
          <PopoverContextProvider>
            <MainContent />
          </PopoverContextProvider>
        </TruDomainWrapper>
      </AppWrapper>
    </BrowserRouter>
  );
};
